<template>
  <v-list-item-content>
    <v-list-item-title class="list-title">
      <slot></slot>
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'NavDrawerListItemText',
};
</script>
